import { categoryConstants } from "../actions/constants/categoryContansts";

export const getCategoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case categoryConstants.getCategoryRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case categoryConstants.getCategorySuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                categorydata: action.payload
            }
        case categoryConstants.getCategoryFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createCategoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case categoryConstants.categoryCreateRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case categoryConstants.categoryCreateSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                categorydata: action.payload
            }
        case categoryConstants.categoryCreateFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getCategoryParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case categoryConstants.getCategoryParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case categoryConstants.getCategoryParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                categorydata: action.payload
            }
        case categoryConstants.getCategoryParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const deleteCateoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case categoryConstants.categoryDeleteRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case categoryConstants.categoryDeleteSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                categorydelete: action.payload
            }
        case categoryConstants.categoryDeleteFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const toggleCategoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case categoryConstants.categoryToggleRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case categoryConstants.categoryToggleSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                categorydata: action.payload
            }
        case categoryConstants.categoryToggleFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const viewCategoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case categoryConstants.categoryViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case categoryConstants.categoryViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                categoryData: action.payload
            }
        case categoryConstants.categoryViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}
